import React from "react";
import {
  InputLabel,
  FormControl,
  Select,
  Divider,
  Typography,
  Button,
  Grid,
  MenuItem,
  TextField,
  Switch,
} from "@common-ui/ui";
import { useDispatch, useSelector } from "react-redux";
import { procedureSlice } from "../../../../reducers/procedureReducer";

const Group = ({
  sectionItem,
  sectionId,
  sectionItemIndex,
  sectionStep,
  step,
  handleRemoveSectionItem,
  subSectionStep,
  subSectionId,
}) => {
  const dispatch = useDispatch();
  const section = useSelector((state) =>
    state.procedure.items.find((section) => section.id === sectionId)
  );
  let subSection;
  if (subSectionId) {
    subSection = section.items.find((section) => section.id === subSectionId);
  }
  const getStep = (id) => {
    if (subSection) {
      // console.log("subSection", subSection);
      return `${subSectionStep}.${
        Array.from(subSection.steps).indexOf(id) + 1
      }`;
    }
    return Array.from(section.steps).indexOf(id) + 1;
  };
  const handleChange = (e, id) => {
    const { name, value } = e.target;
    if (name === "na" || name === "warn") {
      return dispatch(
        procedureSlice.actions.updateSectionItems({
          sectionId,
          sectionItemId: sectionItem.id,
          type: sectionItem.type,
          subSectionId,
          id,
          name,
          value: e.target.checked,
        })
      );
    }
    dispatch(
      procedureSlice.actions.updateSectionItems({
        sectionId,
        sectionItemId: sectionItem.id,
        type: sectionItem.type,
        subSectionId,
        id,
        name,
        value,
      })
    );
  };
  const handleDeleteItem = (id) => {
    dispatch(
      procedureSlice.actions.deleteItem({
        sectionId,
        sectionItemId: sectionItem.id,
        type: sectionItem.type,
        subSectionId,
        id,
      })
    );
  };
  // console.log("group", sectionItem)
  return (
    <div>
      <Grid container spacing={1}>
        <Grid item md={1} xs={12}>
          <div>
            <InputLabel fontWeight="700">Step</InputLabel>
          </div>
        </Grid>
        <Grid item md={1.4} xs={12}>
          <div>
            <InputLabel fontWeight="700">Label</InputLabel>
          </div>
        </Grid>
        <Grid item md={1} xs={12}>
          <div>
            <InputLabel fontWeight="700">Description</InputLabel>
          </div>
        </Grid>
        <Grid item md={1.5} xs={12}>
          <div>
            <InputLabel fontWeight="700">Test Types</InputLabel>
          </div>
        </Grid>
        <Grid item md={1} xs={12}>
          <div>
            <InputLabel fontWeight="700">Allow N/A</InputLabel>
          </div>
        </Grid>
        <Grid item md={1} xs={12}>
          <div>
            <InputLabel fontWeight="700">Checkbox Label</InputLabel>
          </div>
        </Grid>
        <Grid item md={0.6} xs={12}>
          <div>
            <InputLabel fontWeight="700">Repeats</InputLabel>
          </div>
        </Grid>
        <Grid item md={1} xs={12}>
          <div>
            <InputLabel fontWeight="700">Allow Warn</InputLabel>
          </div>
        </Grid>
        <Grid item md={1.5} xs={12}>
          <div>
            <InputLabel fontWeight="700">App URL</InputLabel>
          </div>
        </Grid>
        <Grid item md={1} xs={12}>
          <div>
            <InputLabel fontWeight="700">Configuration</InputLabel>
          </div>
        </Grid>
        <Grid item md={1} xs={12}>
          <div>
            <InputLabel fontWeight="700">Actions</InputLabel>
          </div>
        </Grid>
      </Grid>
      <Divider sx={{ mt: 1 }} />
      {Array.from(sectionItem.items).map((groupItem, index) => {
        return (
          <Grid key={groupItem.id} container spacing={1}>
            <Grid item md={1} xs={12}>
              <Typography
                fontWeight="700"
                sx={{ mt: { md: 1.5 } }}
              >{`${sectionStep}.${getStep(groupItem.id)}
                `}</Typography>
            </Grid>
            <Grid item md={1.4} xs={12}>
              <div>
                <TextField
                  sx={{ mt: 1 }}
                  onChange={(e) => handleChange(e, groupItem.id)}
                  size="small"
                  fullWidth
                  name="label"
                  value={groupItem.label}
                  variant="outlined"
                  placeholder="Example: Cleaning"
                />
              </div>
            </Grid>
            <Grid item md={1} xs={12}>
              <div>
                <TextField
                  sx={{ mt: 1 }}
                  onChange={(e) => handleChange(e, groupItem.id)}
                  size="small"
                  fullWidth
                  placeholder="Example: Clean the cable connector"
                  name="description"
                  value={groupItem.description}
                  variant="outlined"
                />
              </div>
            </Grid>
            <Grid item md={1.5} xs={12}>
              <div>
                {groupItem.test_types === undefined ? (
                  <Typography fontWeight="700" sx={{ mt: { md: 1.5 } }}>
                    ---
                  </Typography>
                ) : (
                  <FormControl fullWidth name="test_types">
                    <Select
                      sx={{ mt: 1 }}
                      onChange={(e) => handleChange(e, groupItem.id)}
                      size="small"
                      placeholder="Select"
                      name="test_types"
                      variant="outlined"
                      value={groupItem.test_types}
                      // displayEmpty
                      // renderValue={() => "Select"}
                    >
                      <MenuItem value={""} disabled>
                        <em>Select</em>
                      </MenuItem>
                      <MenuItem value={"AFFIRMATIVE_PASS"}>
                        Affirmative Pass
                      </MenuItem>
                      <MenuItem value={"AFFIRMATIVE_FAIL"}>
                        Affirmative Fail
                      </MenuItem>
                    </Select>
                  </FormControl>
                )}
              </div>
            </Grid>
            <Grid item md={1} xs={12}>
              <div>
                <FormControl fullWidth name="na">
                  <Switch
                    {...{ inputProps: { "aria-label": "Switch na" } }}
                    inputProps={{ "aria-label": "controlled" }}
                    sx={{ mt: 1.5 }}
                    size="small"
                    onChange={(e) => handleChange(e, groupItem.id)}
                    // size="small"
                    name="na"
                    checked={groupItem.na === true}
                    // value={groupItem.na}
                  />
                </FormControl>
              </div>
            </Grid>
            <Grid item md={1} xs={12}>
              <div>
                {groupItem.checkbox_label === undefined ? (
                  <Typography fontWeight="700" sx={{ mt: { md: 1.5 } }}>
                    ---
                  </Typography>
                ) : (
                  <TextField
                    sx={{ mt: 1 }}
                    onChange={(e) => handleChange(e, groupItem.id)}
                    size="small"
                    fullWidth
                    name="checkbox_label"
                    value={groupItem.checkbox_label}
                    variant="outlined"
                  />
                )}
              </div>
            </Grid>
            <Grid item md={0.6} xs={12}>
              <div>
                {groupItem.repeat === undefined ? (
                  <Typography fontWeight="700" sx={{ mt: { md: 1.5 } }}>
                    ---
                  </Typography>
                ) : (
                  <TextField
                    sx={{ mt: 1 }}
                    onChange={(e) => handleChange(e, groupItem.id)}
                    size="small"
                    fullWidth
                    type="number"
                    name="repeat"
                    inputProps={{
                      min: "1",
                    }}
                    value={groupItem.repeat}
                    variant="outlined"
                  />
                )}
              </div>
            </Grid>
            <Grid item md={1} xs={12}>
              <div>
                <FormControl fullWidth name="warn">
                  <Switch
                    {...{ inputProps: { "aria-label": "Switch warn" } }}
                    inputProps={{ "aria-label": "controlled" }}
                    sx={{ mt: 1.5 }}
                    size="small"
                    onChange={(e) => handleChange(e, groupItem.id)}
                    // size="small"
                    name="warn"
                    checked={groupItem.warn === true}
                    // value={groupItem.warn}
                  />
                </FormControl>
              </div>
            </Grid>
            <Grid item md={1.5} xs={12}>
              <div>
                {groupItem.url === undefined ? (
                  <Typography fontWeight="700" sx={{ mt: { md: 1.5 } }}>
                    ---
                  </Typography>
                ) : (
                  <TextField
                    sx={{ mt: 1 }}
                    placeholder="Example: https://wwww.example.com"
                    onChange={(e) => handleChange(e, groupItem.id)}
                    size="small"
                    fullWidth
                    name="url"
                    value={groupItem.url}
                    variant="outlined"
                  />
                )}
              </div>
            </Grid>
            <Grid item md={1} xs={12}>
              <div>
                {groupItem.configuration === undefined ? (
                  <Typography fontWeight="700" sx={{ mt: { md: 1.5 } }}>
                    ---
                  </Typography>
                ) : (
                  <TextField
                    sx={{ mt: 1 }}
                    onChange={(e) => handleChange(e, groupItem.id)}
                    size="small"
                    placeholder="Example: config"
                    fullWidth
                    name="configuration"
                    value={groupItem.configuration}
                    variant="outlined"
                  />
                )}
              </div>
            </Grid>
            <Grid item md={1} xs={12}>
              <div>
                <InputLabel fontWeight="700">
                  <Button
                    // startIcon={<DeleteForever />}
                    sx={{ fontWeight: 200, mt: { md: 1.5 } }}
                    size="small"
                    onClick={() => handleDeleteItem(groupItem.id)}
                  >
                    Remove
                  </Button>
                </InputLabel>
              </div>
            </Grid>
          </Grid>
        );
      })}
      {/* <span style={{ display: "flex", alignItems: "center" }}>
        <Typography sx={{ mr: 1 }}>{`${sectionStep}.${getStep(
          sectionItem.id
        )}`}</Typography>

        <Button
          // onClick={() => handleRemoveSubSection(subSection.id)}
          // startIcon={<DeleteForever />}
          sx={{ fontWeight: 200 }}
          size="small"
        >
          Remove
        </Button>
      </span> */}
      {/* <div>Coming Soon!</div>  */}
      <Divider sx={{ my: 2 }} />
    </div>
  );
};

export default Group;
